/* eslint-disable no-nested-ternary */
import React from 'react';

import PropTypes from 'prop-types';

export default function Input({
  id,
  name,
  label,
  type,
  disabled,
  hasError,
  hasWarn,
  errorText,
  warnText,
  helpText,
  className,
  ...props
}) {
  const hasAlertClassName = hasError
    ? 'sdp-fieldset--error'
    : hasWarn
    ? 'sdp-fieldset--warning'
    : '';
  return (
    <div
      className={`sdp-fieldset ${hasAlertClassName}`}
      data-testid="input-component"
    >
      <label
        className="sdp-form-label"
        htmlFor={id}
        data-testid="input-component_title"
      >
        {label}
      </label>
      {type === 'text-area' ? (
        <textarea
          className={`sdp-form-input sdp-textarea ${className}`}
          id={id}
          name={name}
          disabled={disabled}
          data-testid="input-component_textarea"
          {...props}
        />
      ) : (
        <input
          id={id}
          name={name}
          disabled={disabled}
          type={type}
          className={`sdp-form-input ${className}`}
          data-testid="input-component_input"
          {...props}
        />
      )}
      {hasWarn && (
        <label className="sdp-form-feedback" htmlFor={id}>
          {warnText}
        </label>
      )}
      {hasError && (
        <label className="sdp-form-feedback" htmlFor={id}>
          {errorText}
        </label>
      )}
      {!!helpText && (
        <label className="sdp-form-feedback d-flex" htmlFor={id}>
          {helpText}
        </label>
      )}
    </div>
  );
}

Input.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  label: PropTypes.string,
  type: PropTypes.oneOf(['text', 'text-area', 'email', 'password', 'number']),
  disabled: PropTypes.bool,
  hasError: PropTypes.bool,
  hasWarn: PropTypes.bool,
  errorText: PropTypes.string,
  warnText: PropTypes.string,
  helpText: PropTypes.string,
  className: PropTypes.string
};

Input.defaultProps = {
  id: 'myInput',
  name: 'myInput',
  label: 'My Input Label',
  type: 'text',
  disabled: false,
  hasError: false,
  hasWarn: false,
  errorText: '',
  warnText: '',
  helpText: '',
  className: ''
};
